import { ResourceLanguage } from 'i18next'

import { enSG } from './en-sg'
import { zhSG } from './zh-sg'

export const locales = {
  'en-SG': enSG as unknown as ResourceLanguage,
  'zh-SG': zhSG as unknown as ResourceLanguage,
}
